import { Routes } from '@angular/router';
import { inject } from '@angular/core';

import { AdminGuardService as AdminGuard } from './auth/admin-guard.service';

import { PublicAccessComponent } from './public/public-access.component';
import { RestrictedAccessComponent } from './restricted/restricted-access.component';
import { PainelComponent } from './painel/painel.component';
import { TermsGuard } from './guard/terms.guard';
import { TenantService } from './white-label/services/tenant.service';


export const ROUTES: Routes = [
  // Página de impressão de PDF (Selenium do backend). Precisa vir ANTES da rota
  // white-label: no domínio do tenant `isWhiteLabel` é true e o WhiteLabelModule
  // capturaria qualquer path. Sem guard e sem shell — a auth vem do ticket.
  {
    path: 'reports/print/analysis',
    loadChildren: () => import('./reports-print/reports-print.module').then(m => m.ReportsPrintModule)
  },
  {
    path: '',
    canMatch: [() => inject(TenantService).isWhiteLabel],
    loadChildren: () => import('./white-label/white-label.module').then(m => m.WhiteLabelModule)
  },
  {
    path: '',
    component: PublicAccessComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./public/public-access.module').then(m => m.PublicAccessModule)
      }
    ]
  },
  {
    path: '',
    component: RestrictedAccessComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./restricted/restricted-access.module').then(m => m.RestrictedAccessModule),
      }
    ]
  },
  {
    path: '',
    component: PainelComponent,
    canActivate: [AdminGuard, TermsGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./painel/painel.module').then(m => m.PainelModule)
      }
    ]
  },
  { path: 'admin', redirectTo: 'painel/dashboard' },
  { path: '**', redirectTo: 'home' }
];
